export default "__VITE_ASSET__Bllrzf8E__"